import Controller, { inject as controller } from "@ember/controller";

export default class LoginRequiredController extends Controller {
  @controller application;
}
